// AttendanceService.ts
import { get, post } from './mainApi';
import { generateId } from 'src/utils/traceIdGenerations';
import axios from 'axios';
import { createHeader } from './mainApi';

const baseUrl = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT + 'event-management/event_attendance';

/**
 * GET: Fetch attendee list for a given event ID
 */
export const getAttendanceListByEventId = async (eventId: number) => {
  const traceId = generateId(9);
  return await get(`${baseUrl}/${eventId}?traceId=${traceId}`);
};

/**
 * POST: Submit updated attendance list with participation
 */
export const saveAttendanceList = async (data: {
  id: number;
  eventId: number;
  employeeId: string;
  employeeName: string;
  participations: string;
}[]) => {
  const traceId = generateId(9);
  return await postRaw(`${baseUrl}?traceId=${traceId}`, data);
};

const postRaw = async (url: string, data: any) => {
  const config = await createHeader();
  return await axios.post(url, data, config); // ✅ Pass array directly
};
